var bighouse = bighouse || {};

bighouse.searchTags = (function () {


    function init() {
        bindTagEvents();
    }


    function addTag(value, label, name){

        var data = {
            "value" : value,
            "label": label,
            "name" : name
        };
        
        var tagString = util.template(tagMarkup, data);

        $('.js-searchTagList').append(tagString); 
    }


    function unbindTagEvents(){
        $('.js-searchTag').off('click', removeTag);
    }

    function bindTagEvents(){
        $('.js-searchTag').on('click', removeTag);
    }


    function removeTag(e){
        var value = $(e.target).attr('data-value');
        var name = $(e.target).attr('data-name');

        switch (name) {
            case 'partysizemin':
                bighouse.rangeSlider.resetPartySize();
                break;
            case 'bedroomsquantitymin':
                bighouse.rangeSlider.resetBedroomsQuantity();
                break;
            case 'datefrom':
                $('input[name="' + name + '"]').val('');
                bighouse.searchFilters.clearNights(true); //also remove number of nights
                $('.js-applyDates').trigger('click');
                break;
            case 'nights':
                bighouse.searchFilters.clearNights(false);
                $('.js-applyDates').trigger('click');
                break;
            default:
                $('input[name="' + name + '"][value="' + value + '"]').trigger('click');
        }
       
        e.preventDefault();
    }

    function removeAllTags(){
        $('.js-searchTagList').html(''); 
    }

    function checkTagList(){
        if(  $('.js-searchTagList li').length > 0 ){
            $('.js-searchTagContainer').removeClass('u-hide');
        } else {
            $('.js-searchTagContainer').addClass('u-hide');
        }
    }


    var tagMarkup = '<li class="SearchHeader-tag"><span>{{label}}</span><a href="#" class="js-searchTag" data-value="{{value}}" data-name="{{name}}"><span class="u-visuallyHidden">Remove Filter</span></a></li>';


    return {
        init: init,
        addTag: addTag,
        bindTagEvents: bindTagEvents,
        checkTagList: checkTagList,
        removeAllTags: removeAllTags
    };
})();